export function formatClock(ms) {
  const total = Math.max(0, Math.floor(Number(ms || 0) / 1000));
  const minutes = Math.floor(total / 60);
  const seconds = String(total % 60).padStart(2, '0');
  return `${minutes}:${seconds}`;
}

export function formatRemaining(progressMs, durationMs) {
  const remaining = Math.max(0, Number(durationMs || 0) - Number(progressMs || 0));
  return `-${formatClock(remaining)}`;
}

export function artistNames(track) {
  return (track?.artists || []).map((artist) => artist.name).filter(Boolean).join(', ');
}

export function parseAppleMusicUri(uri) {
  if (!uri || typeof uri !== 'string') return null;
  const match = uri.match(/^applemusic:(song|playlist|album|artist):(.+)$/i);
  if (!match) return null;
  return { kind: match[1].toLowerCase(), id: match[2] };
}

export function playlistUri(playlist) {
  if (!playlist) return null;
  if (playlist.uri) return playlist.uri;
  const id = playlist.id || playlist.playlistId;
  return id ? `applemusic:playlist:${id}` : null;
}

export function songUri(track) {
  if (!track) return null;
  if (track.uri) return track.uri;
  const id = track.id || track.trackId;
  return id ? `applemusic:song:${id}` : null;
}

export function artworkUrlFromItem(item) {
  const artwork = item?.attributes?.artwork;
  if (!artwork?.url) return null;
  return String(artwork.url)
    .replace('{w}', '600')
    .replace('{h}', '600');
}

export function trackFromNowPlayingItem(item, prevTrack = null) {
  if (!item) return prevTrack || null;
  const attrs = item.attributes || {};
  const id = item.id || attrs.playParams?.id || null;
  const artists = attrs.artistName
    ? [{ id: null, name: attrs.artistName }]
    : [];
  return {
    id,
    name: attrs.name || item.title || 'Unknown',
    uri: id ? `applemusic:song:${id}` : null,
    duration_ms: Number(attrs.durationInMillis || item.playbackDuration || 0),
    artists,
    image_url: artworkUrlFromItem(item),
    is_saved: prevTrack?.id === id ? Boolean(prevTrack?.is_saved) : false,
  };
}
